<template>
    <div class="row" :data-expand="isExpand ? true : null">
        <div class="cells" v-on:click="toggleExpand()">
            <span class="cell" data-size="status" data-align="center">
                <span class="icon-status" :data-icon="histItem.userNm == 'System' ? 'system' : 'user'" :title="histItem.userNm == 'System' ? 'System' : 'User'">System</span>
            </span>
            <span class="cell" data-size="date">
                <time datetime="">{{convertUtcTimezoneToLocal(histItem.timeLine)}}</time>
            </span>
            <span class="cell" data-size="type">
                {{ $t('AUDIT.FILTER.RULE')}}<!--규칙-->
            </span>
            <span class="cell" data-size="user">
                {{histItem.userNm}}
            </span>
            <span class="cell">
                {{$t('AUDIT.LABEL.CASE.ACTION')}} : <a href="#">{{histItem[$i18n.locale+'RuleTitle'] || histItem.ruleNm}}</a>
            </span>
            <span class="cell" data-align="center">
                <button type="button" class="buttons-icon" data-type="ghost" data-icon="expand" :data-expand="isExpand ? true : null">collapse / expand</button>
            </span>
        </div>

        <div class="expand-container">
<!--            <div-loading v-if="isExpand"></div-loading>-->
            <!-- inner tables -->
            <table class="tbl-inner">
                    <caption> {{$t('AUDIT.LABEL.CASE.ACTION')}}</caption>
                <colgroup>
                    <col style="width: 185px;">
                </colgroup>
                <thead>
                <tr>
                    <th scope="col">{{ $t('AUDIT.LABEL.HEADER.ITEM')}}<!--항목--></th>
                    <th scope="col">{{ $t('AUDIT.LABEL.HEADER.DETAIL_CONTENTS')}}<!--상세 내용--></th>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <th>{{ $t('AUDIT.ACTION.NAME')}}<!--이름--></th>
                    <td>{{histItem.userDefiYn == constants.PARAM.SELECT.N ? histItem[$i18n.locale+'Title'] : histItem.plcyNm}}</td>
                </tr>
                <tr>
                    <th>{{ $t('AUDIT.ACTION.APPLIED_RULES')}}<!--적용된 규칙--></th>
                    <td>{{histItem[$i18n.locale+'RuleTitle'] || histItem.ruleNm}}</td>
                </tr>
                <tr>
                    <th>{{ $t('AUDIT.ACTION.MESSAGE')}}<!--적용된 규칙--></th>
                    <td>
                        <span class="item" v-html="getHtml(histItem.evntLog)"></span>
                    </td>
                </tr>
                </tbody>
            </table>

        </div>
    </div>

</template>

<script>
    import {mapGetters} from "vuex";

    export default {
        name: 'ExpandActionExecute',
        props: ['histItem'],
        data: function() {
          return {
              plcyInfo: null,
              arrRuleInfo: null,
              isExpand: false
          }
        },
        computed: {
            ...mapGetters({
                curCmpnId: 'user/curCmpnId'
            }),
            getLocale: function() {
                return this.$i18n.locale
            }
        },
        methods: {
            selectGovernancePolicyInfo() {

                const url = `/api/governance/audit/expand/policy/info`

                let ruleData = {
                    'cmpnId': this.curCmpnId,
                    'rvsnId': this.histItem.afRvsnId
                }
                this.http.post(url, ruleData)
                    .then((result) => {
                        if(result.data.status == 'ok') {

                            let arrPlcyInfo = result.data.result

                            this.plcyInfo = arrPlcyInfo !== null && arrPlcyInfo.length > 0 ? _.union(arrPlcyInfo, 'plcyTitl')[0] : null
                            this.arrRuleInfo = arrPlcyInfo
                        } else {
                            // TODO :: Error 처리
                        }
                    }).catch(error => {
                    // TODO :: Error 처리
                });
            },
            convertUtcTimezoneToLocal: function(date) {
                return date == null ? '-' : this.Common.convertUtcTimezoneToLocalByLang(date, this.getLocale)
            },
            toggleExpand: function(){
                this.isExpand = !this.isExpand
                //this.isExpand && this.plcyInfo == null ? this.selectGovernancePolicyInfo() : false
            },
            getHtml: function(evntLog){
                let returnVal = '';
                const self = this;
                if(evntLog  !== undefined && this.Common.isJSON(evntLog)){
                    _.forEach(JSON.parse(evntLog), function(val){
                        returnVal = returnVal.concat("--------------------",  ' <br/> ' );
                        if(_.hasIn(val, "receiver")){
                            let temp = "    * "+ self.$t('AUDIT.LABEL.CASE.RECIPIENT')+" : " + val['receiver'];
                            returnVal = returnVal.concat(temp,  ' <br/> ' );
                        }
                        if(_.hasIn(val, "result")){
                            let temp = "    * "+ self.$t('AUDIT.LABEL.CASE.SUCCESS_FAILURE')+" : " + val['result'];
                            returnVal = returnVal.concat(temp,  ' <br/> ' );
                        }
                    });
                }
                return returnVal;
            }
        }

    }
</script>



// WEBPACK FOOTER //
// src/components/audit/expand/actionExecute.vue